import { cn } from '@/lib/utils';

interface LoadingSkeletonProps {
  className?: string;
  /** Full-page mode: fills viewport with centered skeleton blocks */
  fullPage?: boolean;
}

function Bone({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-muted',
        className,
      )}
      aria-hidden="true"
    />
  );
}

/**
 * Reusable loading skeleton used while auth state or data is resolving.
 */
export function LoadingSkeleton({ className, fullPage = false }: LoadingSkeletonProps) {
  if (fullPage) {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-background"
        role="status"
        aria-label="Loading application"
      >
        <div className="w-full max-w-sm space-y-4 px-4">
          <Bone className="h-8 w-3/4" />
          <Bone className="h-4 w-full" />
          <Bone className="h-4 w-5/6" />
          <Bone className="h-4 w-2/3" />
        </div>
      </div>
    );
  }

  return (
    <div
      className={cn('space-y-3', className)}
      role="status"
      aria-label="Loading"
    >
      <Bone className="h-6 w-3/4" />
      <Bone className="h-4 w-full" />
      <Bone className="h-4 w-5/6" />
    </div>
  );
}
